export function readMeta(name: string, attribute?: string): string | null {
  const tag = document.querySelector(`meta[name=${name}]`) as HTMLElement;
  if (tag == null) {
    return null;
  }

  if (attribute) {
    return tag.getAttribute(attribute);
  }
  return tag.getAttribute('content');
}

export function readMetaBoolean(name: string, attribute?: string): boolean {
  const stringValue = readMeta(name, attribute);
  if (stringValue && stringValue.toLowerCase() === 'true') {
    return true;
  }
  return false;
}

export function readDataNode(): DOMStringMap {
  const appNode = document.getElementById('app');

  if (appNode == null) {
    throw new Error('App node not found. Aborting.');
  }

  return appNode.dataset;
}

export default {
  readMeta,
};
